import { toast, ToastContainer } from 'react-toastify';

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import loading from "../../assets/images/loading.gif"
import { makeGetRequest } from '../../request';
import { Users } from '../../interfaces/index.types';
import Pagination from '../../components/Pagination';
import Layout from '../Layout';

const FreightForwarder =  () => {
    const navigate = useNavigate()
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const [startIndex, setStartIndex] = useState(0);
    const getPageNumbers = () => {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            if (currentPage >= startIndex + 4) {
                setStartIndex(startIndex + 4);
            }
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            if (currentPage - 1 <= startIndex) {
                setStartIndex(startIndex - 4);
            }
        }
    };

    const handleCopy = (text: string) => {
        // Implement the copy logic here
        const tempTextArea = document.createElement("textarea");
        tempTextArea.value = text;
    
        // Make the textarea non-editable to avoid focus and activation
        tempTextArea.setAttribute("readonly", "");
        tempTextArea.style.position = "absolute";
        tempTextArea.style.left = "-9999px";
    
        document.body.appendChild(tempTextArea);
        tempTextArea.select();
    
        try {
            // Copy the text to the clipboard
            document.execCommand("copy");
            toast.info(`Copied! - ${text}`)
        } catch (err) {
            toast.error("Unable to copy selected item: " + err);
        } finally {
            document.body.removeChild(tempTextArea);
        }
      };

    const [users, setUsers] = useState<Users[]>()
    // const [selectedFreightForwarderId, setSelectedFreightForwarderId] = useState("")
    const [searchValue, setSearchValue] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const GetAllUsersForAThirdPartyRole = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "GetAllUsersForAThirdPartyRole",
            params: {
                page: currentPage,
                pageSize: itemsPerPage,
                roleName: "FreightForwarder"
            }
        };
        if(searchValue) request.params.SearchString = searchValue
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setUsers(res)
                setTotalItems(response.data.totalCount)
            })
            .catch((error:any) => 
                toast.error(error.errorMessage)
            );
    }
    const row = users?.map((user, index) => {
        return (
                <tr key={index}>
                    <td>{ currentPage === 1 ? currentPage + index : (((itemsPerPage*currentPage)-itemsPerPage)+1) + index }</td>
                    <td className='uppercase'>{ user?.user.companyName }</td>
                    <td><span onClick={() => handleCopy(user?.user.email)} className="material-symbols-outlined mr-2" style={{fontSize: "16px", cursor: "pointer"}}>content_copy</span>
                        { user?.user.email }
                    </td>                    
                    {/* <td>
                        <button onClick={() => navigate(`/transitofficer/freightforwarder-assigned-material-readiness-documents/${user?.user.email}`)} className="actions">
                            <span className="material-symbols-rounded">pageview</span>
                            <span>View Details</span>
                        </button>
                    </td> */}
                    <td className="actions">
                        <div className="dropdown">
                            <button className="dropbtn-2"><span className="material-symbols-outlined" style={{fontSize: "24px"}}>more_horiz</span></button>
                            <div className="dropdown-content">
                                <button
                                onClick={() => {navigate("/shippingofficer/batch-assign-material-readiness-documents/" + user?.user.email);}}
                                >Batch Assign MRDs</button>

                                <button
                                onClick={() => {
                                    navigate("/shippingofficer/freightforwarder-assigned-material-readiness-documents/" + user?.user.email);}}
                                >View Assigned MRDs</button>
                            </div>
                        </div>
                    </td>
                </tr>
        )
    })

    useEffect(() => {
        GetAllUsersForAThirdPartyRole();
        // setSelectedPurchaseOrders(purchaseOrders?.selectedPurchaseOrders)
        // eslint-disable-next-line
    }, [currentPage, itemsPerPage, searchValue])

    const handleSearch = (event: any) => {
        const value = event.target.value
        if(!value) setSearchValue("")
    }

    // const removePurchaseOrder = (id: string) => {
    //     setSelectedPurchaseOrders(selectedPurchaseOrders.filter((purchaseOrder: any) => purchaseOrder.id !== id))
    // }

    const page = "Freight Forwarder Assignment"

    return (
        <Layout title={page}>
           <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3> 
                    <div className="main-inner mt-1">
                        <div className="main-inner-top">
                            <div className="d-flex">
                                <div className="search-container left-item">
                                    <span className="material-symbols-rounded">search</span>
                                    <input id="search" placeholder="Search Freight Forwarders" onKeyUp={handleSearch} />
                                </div>
                                <button className="custom-button orange left-item ml-2"
                                    onClick={() => {setSearchValue((document.getElementById("search") as HTMLInputElement)?.value); setCurrentPage(1)}}
                                >Search</button>
                            </div>                            
                        </div>                                              
                        <div className='table-container custom' style={{minHeight: "450px"}}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>SN</th>
                                        <th>Company</th>    
                                        <th>Official Email</th>
                                        <th style={{width: "136px"}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {isLoading ? null : (
                                        users?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                        : row
                                    )
                                }
                                </tbody>
                            </table>
                            {isLoading ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null}
                        </div>

                        <div className="pagination-container">
                            <Pagination
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                totalPages={totalPages}
                                handlePrevious={handlePrevious}
                                handleNext={handleNext}
                                setCurrentPage={setCurrentPage}
                                getPageNumbers={getPageNumbers}
                                setItemsPerPage={setItemsPerPage}
                            startIndex={startIndex} />
                        </div> 
                    </div> 
                    {/* For Purchase Orders Assignment  */}
                    {/* <div className="main-inner mt-1" style={{padding: "16px 0"}}>                 
                        <button type="submit" className="custom-button orange"
                            disabled={isSubmitting}
                            onClick={() => AssignBatchPurchaseOrderToFreightForwarder()}
                            style={{margin: "0 auto", height: "36px"}}>
                            <span className="material-symbols-rounded">web_traffic</span>{isSubmitting ? "Assigning..." : "Assign Purchase Order"}
                        </button>
                    </div>                 */}
                </div>
            </div>
            <ToastContainer /> 
        </Layout>
    )
}

export default FreightForwarder